import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { message } from "antd";

type Product = {
  name: string;
  description: string;
};

export const useUpdateCategoryMutation = (id: any) => {
  return useMutation({
    mutationFn: (payload: Product) =>
      axiosInstance
        .patch(`/products/categories/${id}`, payload)
        .then((res: any) => res.data),
    onSuccess: async () => {},
    onError: (error: any) => {
      message.error(error?.response?.data?.message);
    },
  });
};
